/**
 * Brainart CT — Car Rental App — localization helpers (Euro currency + EU dd/mm/yyyy dates).
 *
 * Use these exclusively for user-facing values. Internal storage and API
 * traffic remain ISO 8601 (YYYY-MM-DD) — conversion happens at the UI edge.
 */

const EUR = new Intl.NumberFormat("en-IE", {
  style:                 "currency",
  currency:              "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatEUR(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "€0.00";
  return EUR.format(n);
}

/** e.g. `€49/day`, `–€150.00`, `€1,234.56` */
export function formatEURCompact(value, decimals = 0) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "€0";
  return `€${n.toLocaleString("en-IE", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
}

/** ISO (YYYY-MM-DD) → dd/mm/yyyy. Empty input → empty string. */
export function isoToEU(iso) {
  if (!iso) return "";
  const s = String(iso).slice(0, 10);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (!m) return s;
  return `${m[3]}/${m[2]}/${m[1]}`;
}

/** dd/mm/yyyy → ISO (YYYY-MM-DD). Returns "" for anything invalid. */
export function euToIso(eu) {
  if (!eu) return "";
  const s = String(eu).trim();
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(s);
  if (!m) return "";
  const [_, dd, mm, yyyy] = m;
  const d = Number(dd), mo = Number(mm);
  if (d < 1 || d > 31 || mo < 1 || mo > 12) return "";
  return `${yyyy}-${mm}-${dd}`;
}

/** ISO datetime → dd/mm/yyyy HH:mm */
export function isoToEUDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  const dd = String(d.getUTCDate()).padStart(2, "0");
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  const yyyy = d.getUTCFullYear();
  const hh = String(d.getUTCHours()).padStart(2, "0");
  const mi = String(d.getUTCMinutes()).padStart(2, "0");
  return `${dd}/${mm}/${yyyy} ${hh}:${mi}`;
}
